import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_TRK_89 } from "@/lib/programs/tangerRak89";

export default function TangerRak89Page() {
  return <ProgramTemplate program={PROGRAM_TRK_89} variant="trk" showJourneyChronology />;
}
